import ShowRoomButton from "../button/ShowRoomButton";
import { useMediaQuery } from "react-responsive";

export default function LandingCard(props) {
	const isIpad = useMediaQuery({
		query: "(max-width: 1280px)",
	});

	if (isIpad) {
		return (
			<div className="h-auto my-24 w-full flex justify-center">
				<div className="w-2/3 max-sm:w-4/5">
					<h2 className="text-4xl font-extrabold text-center ">
						{props.title}
					</h2>
					<hr className="w-24 my-6 mx-auto" />
					<div className="w-full mb-7">
						<img
							src={`/images/landing/${props.image}.png`}
							width={500}
							height={400}
							className="w-full h-auto"
						/>
					</div>
					{props.paragraphs?.map((parparagraph, index) => (
						<div key={index} className="">
							<p className="leading-5 text-center">{parparagraph}</p>
							<br />
						</div>
					))}
					<div className="mt-2 text-center">
						<ShowRoomButton handleClick={props.handleClick} />
					</div>
				</div>
			</div>
		);
	}
	return props.picToRight ? (
		<div className="h-auto flex justify-center ">
			<div className="w-1/3 pl-10 mt-20 flex flex-col justify-center bg-[#F6F6F6] py-10">
				<h2 className="text-4xl font-extrabold pr-40 ">{props.title}</h2>
				<hr className="w-24 my-6 " />
				{props.paragraphs?.map((parparagraph, index) => (
					<div key={index}>
						<p className="w-8/12 leading-5 ">{parparagraph}</p>
						<br />
					</div>
				))}
				<img
					src={"/images/landing/environment_logo.png"}
					width={200}
					height={150}
					className="pl-12"
				/>
				<div className="mt-2 ">
					<ShowRoomButton handleClick={props.handleClick} />
				</div>
			</div>
			<div className="w-auto pt-20 mr-32 flex justify-center">
				<img
					src={`/images/landing/${props.image}.png`}
					width={500}
					height={600}
				/>
			</div>
		</div>
	) : (
		<div className="h-auto flex justify-center">
			<div className="w-auto mt-20 flex justify-center">
				<img
					src={`/images/landing/${props.image}.png`}
					width={500}
					height={600}
				/>
			</div>
			<div className="w-1/3 mt-20 ml-32 flex flex-col justify-center py-10">
				<h2 className="text-4xl font-extrabold pr-40">{props.title}</h2>
				<hr className="w-24 my-6" />
				{props.paragraphs?.map((parparagraph, index) => (
					<div key={index}>
						<p className="w-8/12 leading-5 ">{parparagraph}</p>
						<br />
					</div>
				))}
				<div className="mt-2">
					<ShowRoomButton handleClick={props.handleClick} />
				</div>
			</div>
		</div>
	);
}
